// extracted by mini-css-extract-plugin
module.exports = {"PillDropdown":"PillDropdown_PillDropdown__ra01d","pillbox":"PillDropdown_pillbox__3BCyA"};